import { type CatalogueProductFeature } from 'src/App/generated/graphql-types';
import type { ProductSetData } from 'src/hooks';
import { mapAdProductPrice, type MappedPrice } from './mapAdProductPrice';

export type MappedAdProduct = {
  name: string;
  features: {
    type: string;
  }[];
  price: MappedPrice;
};

export type Product = ProductSetData['productSet']['items'][0];

export const mapProductSetItems = (products: Product[]) => {
  return products
    .map(mapProductSetItem)
    .filter((product) => product !== undefined);
};

const mapProductSetItem = (product: Product): MappedAdProduct | undefined => {
  if (product?.__typename !== 'AdProduct') {
    return undefined;
  }

  const price = product.price;
  if (price?.__typename !== 'Price') {
    return undefined;
  }

  const mappedPrice: MappedPrice = mapAdProductPrice(price);

  return {
    name: product.displayMetadata?.name ?? '',
    features: product.features
      .filter((feature): feature is CatalogueProductFeature => feature !== null)
      .map((feature) => ({ type: feature.type })),
    price: mappedPrice,
  };
};
